import axios from 'axios'
import router from '../../router'
const state = {
  reportCompanyList: [],
  reportTypeList: [],
  postStatusList: [],
  postTypeList: [],
  statuses: [],
  groupsCombo: [],
  groupMenuList: [],
  adminCompanyTypeMaps: []
}

const getters = {
  getReportCompanyList (state) {
    return state.reportCompanyList
  },
  getReportTypeList (state) {
    return state.reportTypeList
  },
  getPostStatusList (state) {
    return state.postStatusList
  },
  getPostTypeList (state) {
    return state.postTypeList
  },
  getStatuses (state) {
    return state.statuses
  },
  getGroupsCombo (state) {
    return state.groupsCombo
  },
  getGroupMenuList (state) {
    return state.groupMenuList
  },
  getAdminCompanyTypeMaps (state) {
    return state.adminCompanyTypeMaps
  }
}

const mutations = {
  setReportCompanyList (state, payload) {
    state.reportCompanyList = payload
  },
  setReportTypeList (state, payload) {
    state.reportTypeList = payload
  },
  setPostStatusList (state, payload) {
    state.postStatusList = payload
  },
  setPostTypeList (state, payload) {
    state.postTypeList = payload
    // console.log('state === ' + JSON.stringify(state.postTypeList))
  },
  setStatuses (state, payload) {
    state.statuses = payload
  },
  setGroupsCombo (state, payload) {
    state.groupsCombo = payload
  },
  setGroupMenuList (state, payload) {
    state.groupMenuList = payload
  },
  setAdminCompanyTypeMaps (state, payload) {
    state.adminCompanyTypeMaps = payload
  }
}

const actions = {
  apiReportCompanyAndTypeList (context) {
    axios.get('/api/commons/company-types') // 제보대상 회사구분 List
      .then((response) => {
        context.commit('setReportCompanyList', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
    axios.get('/api/commons/report-types') // 제보유형 List
      .then((response) => {
        context.commit('setReportTypeList', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiPostStatusList (context) {
    axios.get('/api/commons/post-statuses') // 제보글 상태 List
      .then((response) => {
        context.commit('setPostStatusList', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiPostTypeList (context) {
    axios.get('/api/commons/post-types') // 제보 익명/실명 구분
      .then((response) => {
        context.commit('setPostTypeList', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiCommonsStatus (context) {
    axios.get('/api/commons/statuses')
      .then((response) => {
        context.commit('setStatuses', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiAdminCompanyTypeMaps (context) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.get('/api/admin/companyTypeMaps/combo')
        .then((response) => {
          context.commit('setAdminCompanyTypeMaps', response.data)
        })
        .catch((error) => {
          if (error.response.status === 410) {
            sessionStorage.removeItem('token')
            router.push('/sessiontimeout')
          } else {
            alert(error.response.data.message)
          }
        })
    }
  },
  apiAdminGroupMenus (context) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.get('/api/admin/GroupMenus')
        .then((response) => {
          context.commit('setGroupMenuList', response.data)
        })
        .catch((error) => {
          if (error.response.status === 410) {
            sessionStorage.removeItem('token')
            router.push('/sessiontimeout')
          } else {
            alert(error.response.data.message)
          }
        })
    }
  },
  apiSysadminGroupsCombo (context) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.get('/api/sysadmin/groups/combo')
        .then((response) => {
          context.commit('setGroupsCombo', response.data)
        })
        .catch((error) => {
          if (error.response.status === 410) {
            sessionStorage.removeItem('token')
            router.push('/sessiontimeout')
          } else {
            alert(error.response.data.message)
          }
        })
    }
  },
  apiAdminAttachfile (context, payload) {
    axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
    axios.get('/api/admin/attachfile/' + payload.id, {responseType: 'blob'})
      .then((response) => {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = new Blob([response.data])
          window.navigator.msSaveOrOpenBlob(blob, payload.filename)
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', payload.filename)
          document.body.appendChild(link)
          link.click()
        }
      })
      .catch((error) => {
        alert(error.response.data.message)
        if (error.response.status === 410) {
          sessionStorage.removeItem('token')
          router.push('/sessiontimeout')
        }
      })
  },
  apiInformantAttachfile (context, payload) {
    axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
    axios.get('/api/informant/attachfile', {responseType: 'blob'})
      .then((response) => {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = new Blob([response.data])
          window.navigator.msSaveOrOpenBlob(blob, payload.filename)
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: response.headers['content-type']}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', payload.filename)
          document.body.appendChild(link)
          link.click()
        }
      })
      .catch((error) => {
        alert(error.response.data.message)
        if (error.response.status === 410) {
          sessionStorage.removeItem('token')
          router.push('/reportinquiry')
        }
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js